module.exports = __webpack_public_path__ + "static/img/homepages.b5e41843.jpg";